/* global axios */
import ApiClient from './ApiClient';

class DataAssistantReportMembersAPI extends ApiClient {
  constructor() {
    super('data_assistant/reports', { accountScoped: true });
  }

  show(reportId) {
    return axios.get(`${this.url}/${reportId}/members`);
  }

  update(reportId, { userIds, teamIds }) {
    return axios.patch(`${this.url}/${reportId}/members`, {
      user_ids: userIds,
      team_ids: teamIds,
    });
  }
}

export default new DataAssistantReportMembersAPI();
